module.exports = __webpack_public_path__ + "static/media/maf-30.6488360a.png";